// extracted by mini-css-extract-plugin
module.exports = {"separator":"SectionSeparator_separator__Sn7x1","dark":"SectionSeparator_dark__4xDGt"};